import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectClient, selectFaviconURL } from '../../global-selectors';

import { DefaultLayout } from '../../components/Layouts/DefaultLayout';
import { selectBootstrapConfig } from '../../queries/selectors/bootstrap';
import { injectIntl } from 'react-intl';

const mapStateToProps = (state) => ({
  bootstrap: selectBootstrapConfig(state),
  client: selectClient(state),
  faviconURL: selectFaviconURL(state),
});

export default compose(
  connect(mapStateToProps),
  injectIntl
)(DefaultLayout);
